export const OPEN_POPUP = 'SideChef/ShopButton/OPEN_POPUP'
export const UPDATE_GROCER = 'SideChef/ShopButton/UPDATE_GROCER'
export const BUTTON_IMPRESSION = 'SideChef/ShopButton/BUTTON_IMPRESSION'
export const SHOW_SPONSORED_PRODUCT = 'SideChef/ShopButton/SHOW_SPONSORED_PRODUCT'
export const ANALYTICS_CONSENT_CHANGED = 'SideChef/ShopButton/ANALYTICS_CONSENT_CHANGED'

export const openPopupMessage = () => ({ type: OPEN_POPUP })
export const updateGrocerMessage = ({ grocer }) => ({ type: UPDATE_GROCER, grocer })
export const buttonImpressionMessage = ({ count }) => ({ type: BUTTON_IMPRESSION, count })

export const buildBroadcastMessage = (eventName, payload) => ({ eventName, ...payload })

export const postMessage = (message, sender = parent, targetOrigin = window.props.referrer) => {
  sender.postMessage(message, targetOrigin)
}

export const postBroadcastMessage = message => {
  postMessage(message, window, window.location.origin)
}
